export type QueryOperator =
  | "eq"
  | "ne"
  | "gt"
  | "gte"
  | "lt"
  | "lte"
  | "between"
  | "in"
  | "min"
  | "max"
  | "iLike"
  | "notILike";

export enum InvoiceModes {
  Netto = "Netto",
  Brutto = "Brutto",
}

export type PartialExcept<T, K extends keyof T> = Partial<T> & Pick<T, K>;

export type InvoiceFilterFields =
  | "createdAt"
  | "status"
  | "supplierId"
  | "accountId"
  | "exportId"
  | "isPaid"
  | "smbReviewStatus";
